module.exports = __webpack_public_path__ + "static/beheld-c812a559f395e9770ed7054a3f6063b4.jpg";